/** forma_pago 73 = Hub de Pagos */
export function esFormaPagoHubPagos(t) {
  const fp = t?.forma_pago ?? t?.formaPago;
  return Number(fp) === 73 || String(fp ?? "").trim() === "73";
}

/** valor_datafono de la fila solo si es Hub; si no, cadena vacía (export Excel). */
export function valorHubPagosFila(t) {
  if (!esFormaPagoHubPagos(t)) return "";
  const raw = t?.valor_datafono;
  if (raw == null || raw === "") return "";
  const v = Number(raw);
  return Number.isFinite(v) ? v : "";
}
